import { ApiHelper, Http } from "lib/api/base";

import { ContentHome } from "lib/data";

export class ContentHomeApi {

	public static getContentHome = async (): Promise<ContentHome | undefined> => {

		// Configure Url
		const url: string = `${window.location.origin}/contenthome`;

		// Make Request
		const response: Response = await Http.httpGet(url, undefined);

		// Check Response
		if (response.ok) {

			// Parse Response Body
			const contentSections: ContentHome = await ApiHelper.parseResponseBody(response);

			return contentSections;
		}

		// TODO: Handle Errors

		// Return Nothing
		return undefined;
	}

	public static updateContentHome = async (contentHome: ContentHome): Promise<ContentHome | undefined> => {

		// Configure Url
		const url: string = `${window.location.origin}/contenthome/${contentHome.id}`;

		// Make Request
		const response: Response = await Http.httpPut(url, {...contentHome, Id: contentHome.id.toString(), id: contentHome.id.toString()});

		// Check Response
		if (response.ok) {

			// Parse Response Body
			const contentSections: ContentHome = await ApiHelper.parseResponseBody(response);

			return contentSections;
		}

		// TODO: Handle Errors

		// Return Nothing
		return undefined;
	}
}
